import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    redirect: { name: 'multi-labeling' },
  },
  {
    path: '/multi-labeling',
    name: 'multi-labeling',
    component: () => import(/* webpackChunkName: "multi-labeling" */ '../pages/multi-labeling'),
    meta: {
      title: 'Multi-server-labeling'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../pages/login'),
    meta: {
      title: 'Login'
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../pages/register'),
    meta: {
      title: 'Register'
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../pages/profile'),
    meta: {
      requiresAuth: true,
      title: 'My Account'
    },
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../pages/404'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'login') {
    next({ name: 'multi-labeling' })
    return
  }

  if (to.name === 'register') {
    await store.dispatch('user/logout')
    next()
    return
  }

  next()
})

router.afterEach((to, /* from */) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || 'gl-multi-server-admin-ui'
  })
})

router.onError(error => {
  console.error(error);
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    window.location.reload();
  }
  else if (/Loading.*chunk.*failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router
